import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, merge } from 'lodash-es';

// Constants
import { LEAD_FORM_CONFIGS, STRATEGIES } from 'site-modules/shared/constants/lead-form/lead-form-configs';
import { CARD_VIEW, LEAD_FORM_VIEWS, THANK_YOU_VIEWS } from 'site-modules/shared/constants/lead-form/lead-form-params';

// Components
import { UnifiedLeadFormAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/unified-lead-form-async';
import { sendMarketoThankYouEmail } from 'site-modules/shared/components/lead-form/lead-form-wrapper/lead-form-wrapper-methods';
// Utils
import { isMakePorsche } from 'site-modules/shared/utils/inventory/make';
import { isRoiTargetedFlavor } from 'client/utils/flavor-targeting';
import { VisitorModel } from 'client/data/models/visitor';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { getMultiDigitalRetailLeadFormPropsCommon } from './multi-digital-retail-offer-type-lead-form-config-utils';

function MultiDigitalRetailOfferTypeLeadFormSrpNewUI({
  params,
  options,
  pageName = '',
  visitorId = null,
  userSet = undefined,
  stateCode = undefined,
}) {
  const isUserSetZip = !!userSet;
  const postProcessMethods = sendMarketoThankYouEmail;
  // After using the merge function from lodash, the React elements are not copied completely,
  // which causes a React warning "Each child in a list should have a unique key".
  // To prevent this, need to add the keys manually.
  const subtitle = (
    <div className="mb-1_5">
      <div key={1} className="mb-1">
        Did you know? You should know exactly what you should pay for a car before you test drive it.
      </div>
      <div key={2}> We&apos;ll show you what to pay on the next page.</div>
    </div>
  );

  const newFormProps = {
    customConfig: {
      tags: null,
      leadFormComponent: LEAD_FORM_VIEWS.MULTI_DIGITAL_RETAIL_OFFER_TYPE_SRP_NEW,
      leadFormConfig: {
        cardView: CARD_VIEW.DEALER_VIN_SRP_NEW,
        title: isMakePorsche(params.make)
          ? 'Save with Edmunds'
          : '[savingsValue=0?Save with Edmunds:Save {savingsValue} with Edmunds]',
        titleClassName: 'text-blue-50 fw-bold size-24 mb-1 mb-md-1_5',
        subtitle,
      },
      thankYouComponent: THANK_YOU_VIEWS.SRP_PRICE_CHECKER,
      thankYouConfig: {
        isNewVinOnSrp: true,
        getLeadFormSrpLinkAttributes: get(options, 'getLeadFormSrpLinkAttributes'),
      },
    },
    config: isRoiTargetedFlavor()
      ? { ...LEAD_FORM_CONFIGS.UNIFIED_PURCHASE, strategy: STRATEGIES.PURCHASE_TARGET_ROI }
      : LEAD_FORM_CONFIGS.UNIFIED_PURCHASE,
  };

  const formProps = merge(
    getMultiDigitalRetailLeadFormPropsCommon({
      params,
      options,
      visitorId,
      pageName,
      postProcessMethods,
      isNewVin: true,
      isUserSetZip,
      stateCode,
    }),
    newFormProps
  );

  return <UnifiedLeadFormAsync {...formProps} />;
}

MultiDigitalRetailOfferTypeLeadFormSrpNewUI.propTypes = {
  params: PropTypes.shape({}).isRequired,
  options: PropTypes.shape({}).isRequired,
  pageName: PropTypes.string,
  visitorId: PropTypes.string,
  userSet: PropTypes.string,
  stateCode: PropTypes.string,
};

const mapStateToProps = state => ({
  pageName: get(state, 'pageContext.legacy.pageName') || get(state, 'pageContext.page.name'),
  visitorId: get(state, 'visitor.id'),
});

export const MultiDigitalRetailOfferTypeLeadFormSrpNew = connect(mapStateToProps)(
  connectToModel(MultiDigitalRetailOfferTypeLeadFormSrpNewUI, {
    userSet: bindToPath('location.userSet', VisitorModel),
    stateCode: bindToPath('location.stateCode', VisitorModel),
  })
);
